import type {FC} from 'react';
import type {ProgramAdmissionRead} from 'api/v2';
import {Box, Chip, Icon, IconNames} from '@wellstone-solutions/web';

interface SelectedRowChipsProps {
  selectedRows: Array<ProgramAdmissionRead>;
  onDelete: (id: string) => void;
}

export const SelectedRowChips: FC<SelectedRowChipsProps> = ({
  selectedRows,
  onDelete,
}) => (
  <Box sx={styles.chipWrapper}>
    {selectedRows.map((row) => (
      <Chip
        sx={styles.chip}
        key={row.id}
        label={row.member.name}
        variant="filled"
        onDelete={() => onDelete(row.id)}
        deleteIcon={<Icon name={IconNames.Xmark} />}
      />
    ))}
  </Box>
);

const styles = {
  chipWrapper: {
    mt: 1,
    mb: 2,
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    color: 'onSurface.main',
    backgroundColor: 'secondary4.main',
    margin: 0.5,
    '& .MuiChip-deleteIcon': {
      color: 'primary.main',
    },
  },
};
